import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Waechter from './Waechter';
import Ort from '../../components/Ort';

const Orte = props => (
  <div>
    <Waechter />
    {props.orte.map(ort => <Ort ort={ort} key={ort.name} />)}
  </div>
);

Orte.propTypes = {
  orte: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  orte: state.orte.filter(ort => ort.name !== 'Mein Wächter'),
});

export default connect(mapStateToProps)(Orte);



// WEBPACK FOOTER //
// ./src/js/routes/Orte/index.js